import ajax from "./ajax";

// export function getPage(pageName) {
//   return ajax(`/index/pages?PageSearch[url_slug]=${pageName}`);
// }
export function getPage(pageName) {
  return ajax(`page/index?PageSearch[url_slug]=${pageName}`);
}
